import { BaseModel } from './BaseModel';
import Auth from './Auth';
export class SkillMapping extends BaseModel {
  static get entity() {
    return 'skill_mappings';
  }
  static get fk() {
    return 'skill_mapping_id';
  }
  static primaryKey = 'runningId';
  static fields() {
    return {
      runningId: this.attr(null),
      tscId: this.attr(null),
      title: this.attr(null),
      profLevel: this.attr(null)
    };
  }
  static get globalApiConfig() {
    const headers = {};
    const authToken = Auth.getAppToken();
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return {
      baseURL: process.env.VUE_APP_SKILL_API_BASE_URL,
      headers
    };
  }
  static apiConfig = {
    actions: {
      async fetch(mappingId, save = false) {
        return this.get(`/mapping/${mappingId}`, { save });
      },
      async createMapping(body) {
        return await this.post(`/mapping`, body);
      },
      async updateMapping(mappingId, body) {
        return await this.put(`/mapping/${mappingId}`, body);
      },
      async deleteMapping(mappingId) {
        return await this.delete(`/mapping/${mappingId}`);
      }
    }
  };
}
export default SkillMapping;
